import React from 'react';
import { animated, useSpring } from 'react-spring';

const EachDot = ({ delay }) => {
  //! State
  const [dotAnimation] = useSpring(() => ({
    loop: true,
    delay: delay || 0,
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
  }));

  //! Function

  //! Render
  return <animated.span style={dotAnimation}>.</animated.span>;
};

export default EachDot;
